// extracted by mini-css-extract-plugin
export default {"fr-view":"ImageContainer_fr-view__3B1fK","container":"ImageContainer_container__v5czK","image":"ImageContainer_image__MQ40d"};